import React from 'react';
import './index.css';

export default (props) => {
  const { title, description } = props;
  return (<div className="navigation-card">
    <h1>{ title }</h1>
    <p>{ description }</p>
  </div>);
};



// WEBPACK FOOTER //
// ./src/components/navigation-card/index.jsx